/* eslint-disable react/prefer-stateless-function */
import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { ContextPages, Link } from 'Components/UI/FacetRouter/FacetRouter';
import LabeledVerticalExpander from 'Components/UI/VerticalExpander/LabeledVerticalExpander';
import { NotificationManager } from 'react-notifications';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import SquareButton from 'Components/UI/SquareButton';
import { ScreenContext } from 'Components/Universal/Questionnaire/Screens/Screen';
import { makeHideable } from 'Components/Universal/Questionnaire/Hideable';
import ExtraAreaContext from 'Components/Universal/Questionnaire/ExtraAreaContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import './index.css';
import withViewContext from '../Fields/withViewContext';

const Section = ({
  title,
  children,
  expanded,
  isLastSection,
  sectionKey,
  CountComponent,
  allowContinue,
  hideContinue,
  saveAll,
  saveAllText,
  continueText,
}) => {
  const [signalToSaveAll, setSignalToSaveAll] = React.useState(false);
  const [isInitialRender, setIsInitialRender] = React.useState(true);
  const pages = useContext(ContextPages);
  const isMobile = useMobileLayout();
  const childrenToRender = (saveAll ? React.Children.map(children, childElement => React.cloneElement(childElement, { signalToSaveAll, isInitialRender })) : children);

  return (
    <ScreenContext.Consumer>
      {(context) => {
        let button = (
          <SquareButton
            color="green"
            onClick={() => {
              if (allowContinue && !allowContinue()) {
                displayErrorMessage(
                  new Error('No name for Child'),
                  'Please give your child a name.',
                );
                return;
              }
              setIsInitialRender(false);
              setSignalToSaveAll(!signalToSaveAll);
              NotificationManager.success('Your information has been saved.');
              context.expandNextSection(context.expandedIndex);
            }}
            text={continueText}
          />
        );
        if (hideContinue || (context.isLastSection && context.index === pages.length - 1)) {
          button = null;
        } else if (context.isLastSection || isLastSection) {
          if (saveAll) {
            button = (
              <div>
                <SquareButton
                  color="green"
                  onClick={() => {
                    if (allowContinue && !allowContinue()) {
                      displayErrorMessage(
                        new Error('No name for Child'),
                        'Please give your child a name.',
                      );
                      return;
                    }
                    setIsInitialRender(false);
                    setSignalToSaveAll(!signalToSaveAll);
                    NotificationManager.success('Your information has been saved.');
                  }}
                  text={saveAllText}
                />
                <Link to={pages[context.index + 1].href || '/'}>
                  <SquareButton
                    color="green"
                    text={continueText}
                  />
                </Link>
              </div>
            );
          } else {
            button = (
              <Link to={pages[context.index + 1].href || '/'}>
                <SquareButton
                  color="green"
                  text={continueText}
                />
              </Link>
            );
          }
        }

        return (
          <LabeledVerticalExpander
            expanded={expanded || context.expanded}
            transitionSpeed={0.25}
            title={title}
            collapseSection={context.collapseSection}
            expandedIndex={context.expandedIndex}
            firstElementFocusable
            CountComponent={CountComponent}
            test={`${title}label`}
          >
            <div className={`questionnaire-section ${isMobile ? 'mobile' : ''}`}>
              <div className="inputs">
                {childrenToRender}
                {button}
              </div>
              <ExtraAreaContext.Consumer>
                {rightSide => rightSide(sectionKey)}
              </ExtraAreaContext.Consumer>
            </div>
          </LabeledVerticalExpander>
        );
      }}
    </ScreenContext.Consumer>
  );
};

Section.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  expanded: PropTypes.bool,
  isLastSection: PropTypes.bool,
  hideContinue: PropTypes.bool,
  sectionKey: PropTypes.string.isRequired,
  allowContinue: PropTypes.func,
  CountComponent: PropTypes.any,
  saveAll: PropTypes.bool,
  saveAllText: PropTypes.string,
  continueText: PropTypes.string,
};

Section.defaultProps = {
  isLastSection: false,
  hideContinue: false,
  expanded: false,
  title: '',
  CountComponent: undefined,
  children: <Fragment />,
  allowContinue: () => true,
  saveAll: false,
  saveAllText: 'Save All',
  continueText: 'Continue',
};

export default makeHideable(withViewContext(Section));
